module.exports = __webpack_public_path__ + "static/media/ic_searchtype_islet.010fa85f.svg";